import React from "react";
import { Checkbox, Chip, TextField, Typography, Stack, FormControlLabel, Box } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useSelector } from "react-redux";

export const ClientUDFieldComponent = ({ mode = "view", udFields = [], onChange }) => {
  const { selectedClientData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor || "#1976d2";

  if (!udFields || udFields.length === 0) return null;

  if (mode === "view") {
    const visibleFields = udFields.filter((item) => {
      const isCheckbox =
        item?.udFieldTypeName === "Checkbox" ||
        item?.udFieldTypeId === 1 ||
        item?.fieldTypeId === 1 ||
        item?.fieldTypeName === "Checkbox";

      const valStr = item?.value?.toString().trim().toLowerCase();

      if (isCheckbox) {
        return valStr === "true" || valStr === "false";
      } else {
        return valStr && valStr !== "false" && valStr !== "";
      }
    });

    if (visibleFields.length === 0) return null;

    return (
      <Stack sx={{ gap: 0.5, flexWrap: "wrap" }} direction="row">
        {visibleFields.map((item, index) => {
          const label = item?.udFieldLabel ?? item?.fieldLabel ?? item?.label ?? "";
          const isCheckbox =
            item?.udFieldTypeName === "Checkbox" ||
            item?.udFieldTypeId === 1 ||
            item?.fieldTypeId === 1 ||
            item?.fieldTypeName === "Checkbox";

          if (isCheckbox) {
            const valStr = item?.value?.toString().trim().toLowerCase();
            const isChecked = valStr === "true";
            return (
              <Chip
                key={index}
                size="small"
                sx={{ borderRadius: "5px", fontWeight: "bold", pl: 0.5 }}
                label={label}
                icon={isChecked ? <CheckCircleIcon sx={{ color: "green !important", fontSize: "18px !important" }} /> : <CancelIcon sx={{ color: "red !important", fontSize: "18px !important" }} />}
                variant={isChecked ? "filled" : "outlined"}
              />
            );
          }

          return (
            <Chip
              key={index}
              size="small"
              sx={{ borderRadius: "5px" }}
              label={`${label}: ${item?.value}`}
            />
          );
        })}
      </Stack>
    );
  }

  // mode === "edit" or "add"
  return (
    <Stack spacing={2} mt={1}>
      {udFields.map((field, index) => {
        const isCheckbox =
          field?.udFieldTypeName === "Checkbox" ||
          field?.udFieldTypeId === 1 ||
          field?.fieldTypeId === 1 ||
          field?.fieldTypeName === "Checkbox";

        const label = field?.udFieldLabel ?? field?.fieldLabel ?? field?.label ?? "";

        if (isCheckbox) {
          const isChecked = field?.value !== undefined && field?.value !== ""
            ? (field.value === "true" || field.value === true)
            : (field?.fieldDefaultValue === "true" || field?.fieldDefaultValue === true);

          return (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: CLIENT_ACCENT_COLOR
                    }
                  }}
                  checked={isChecked}
                  onChange={(e) => onChange(field.id || field.udFieldId, e.target.checked, "checkbox")}
                />
              }
              label={
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {label}
                </Typography>
              }
              sx={{ m: 0, width: "100%" }}
            />
          );
        } else {
          // Text input
          const textValue = field?.value !== undefined ? field.value : (field?.fieldDefaultValue || "");
          return (
            <Box key={index} sx={{ width: "100%" }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }} gutterBottom>
                {label}
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={textValue}
                onChange={(e) => onChange(field.id || field.udFieldId, e.target.value, "text")}
                sx={{
                  backgroundColor: "#e4e4e4",
                  borderRadius: "10px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none"
                  }
                }}
              />
            </Box>
          );
        }
      })}
    </Stack>
  );
};
